import { t } from "@/i18n-js/instance";
import { usePaywallCouponApi } from "@circle-react/components/PaywallCoupons/Admin/hooks/usePaywallCouponApi";
import { BaseResource } from "../BaseResource";

export const PaywallCouponResource = ({
  resourceId,
}: {
  resourceId: number;
}) => {
  const { useShowPaywallCoupon } = usePaywallCouponApi({});
  const { data: paywallCoupon, isLoading } = useShowPaywallCoupon(resourceId);

  return (
    <BaseResource
      label={t("settings.workflows.view.resources.paywall_coupon")}
      value={paywallCoupon?.code}
      isLoading={isLoading}
    />
  );
};
